module.exports = {
      id: "chevron-left-usage",
      viewBox: "0 0 6 10",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }